import { useEffect, useState } from "react";

const DISCORD_ID = "1363965448885899264";

const isWithinAllowedDates = () => {
    const now = new Date();
    const start = new Date("2026-05-12T00:00:00"); // May 12, 12:00 AM
    const end = new Date("2026-08-24T23:59:59");   // August 24, 11:59 PM
    return now >= start && now <= end;
};

export default function useDiscordLogin() {
    const [user, setUser] = useState("");

    useEffect(() => {
        if (!isWithinAllowedDates()) return;

        const storedUser = localStorage.getItem("discordUser");
        if (storedUser) {
            setUser(storedUser);
            return;
        }

        const params = new URLSearchParams(window.location.hash.slice(1));
        const accessToken = params.get("access_token");
        if (accessToken) {
            fetch("https://discord.com/api/users/@me", {
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
            })
                .then((res) => res.json())
                .then((user) => {
                    setUser(user.id);
                    localStorage.setItem("discordUser", user.id);
                });
        }
    }, []);

    const startOAuthGrant = () => {
        if (!isWithinAllowedDates()) {
            alert("Login is only available between May 12 and August 24.");
            return;
        }

        const redirect = encodeURIComponent(`${window.location.origin}/`);
        window.open(
            `https://discord.com/api/oauth2/authorize?client_id=${DISCORD_ID}&redirect_uri=${redirect}&response_type=token&scope=identify`,
            "_parent"
        );
    };

    return { loggedIn: user !== "", user, startOAuthGrant };
}
